import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (EmptyWidget) code-splits
// into its own tpl-empty-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'empty-widget',
    name: 'Empty Widget',
    description: 'An empty widget to add items to. This lets you start from scratch and add create custom data entry and presentation forms and widgets.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-empty-widget" */ "./EmptyWidget")),
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'advanced',
    autoHieght: true
});
